// src/components/ResetPasswordPage.js
// Password reset is now handled via the ForgotPasswordPage multi-step flow.
// This page redirects there for backwards compatibility with any bookmarked URLs.
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function ResetPasswordPage() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/forgot-password', { replace: true });
  }, [navigate]);

  return null;
}

export default ResetPasswordPage;
